import React from "react";
import {NavLink} from "react-router-dom";

export default function () {
    const { active } = this.props;

    return (
        <div className="button-group">
            <NavLink to={`/machine`} className={active == "machines" ? "active" : ""}>
                Machines
            </NavLink>
            <NavLink to={`/tool`} className={active == "tools" ? "active" : ""}>
                Tools
            </NavLink>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/toggle/view.js